import React from 'react';
import FileAPI from 'api/FileAPI';

interface ISingleResultRow {
  keyVal?: number;
  transaction?: any;
  selectedItems?: any;
  setSelectedItems?: any;
}

const ProductChildRow: React.FC<ISingleResultRow> = ({
  keyVal = Math.floor(Math.random()),
  transaction,
  selectedItems,
  setSelectedItems,
}) => {
  const handleCheckboxClick = (item: any) => {
    setSelectedItems(item);
  };

  const download = async () => {
    const file = await FileAPI.downloadUploadById(transaction?.id);
    // 1. Create a URL for the file object
    const url = window.URL.createObjectURL(file.result);

    // 2. Create a temporary anchor element
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', transaction.file_name); // Set filename

    // 3. Append to body, click to download, and remove
    document.body.appendChild(link);
    link.click();

    // 4. Cleanup
    link?.parentNode?.removeChild(link);
    window.URL.revokeObjectURL(url); // Free up memory
  };

  return (
    <>
      <div className='screening-results-row' key={keyVal}>
        <div
          className='screening-results-row-default-cell'
          style={{ maxWidth: '48px' }}
        >
          <div
            className='screening-results-row-default-cell-inner'
            style={{ width: '48px' }}
            onClick={() => handleCheckboxClick(transaction ? transaction : [])}
          >
            {selectedItems?.some(
              (item: { id: void }) => item.id === transaction?.id,
            ) ? (
              <div className='full-list-filters-cont-row-icon-item'>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='12'
                  height='12'
                  viewBox='0 0 12 12'
                  fill='none'
                >
                  <path
                    d='M10 3L4.5 8.5L2 6'
                    stroke='var(--text-primary)'
                    strokeWidth='1.6666'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                </svg>
              </div>
            ) : (
              <div className='full-list-filters-cont-row-icon-item-unselected'></div>
            )}
          </div>
        </div>
        <div className='screening-results-row-default-cell' onClick={download}>
          <div className='screening-results-row-default-cell-inner'>
            <div className='screening-results-row-link-cell-text'>
              {transaction?.file_name ?? ''}
            </div>
          </div>
        </div>
        <div className='screening-results-row-default-cell'>
          <div className='screening-results-row-default-cell-inner'>
            <div className='screening-results-row-default-cell-text'>
              {transaction?.file_content_type ?? ''}
            </div>
          </div>
        </div>
        <div className='screening-results-row-default-cell'>
          <div className='screening-results-row-default-cell-inner'>
            <div className='screening-results-row-default-cell-text'>
              {transaction?.file_size ?? ''}
            </div>
          </div>
        </div>
        <div className='screening-results-row-default-cell'>
          <div className='screening-results-row-default-cell-inner'>
            <div className='screening-results-row-default-cell-text'>
              {transaction?.created_at
                ? new Date(transaction.created_at).toLocaleDateString()
                : ''}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductChildRow;
